module.exports = __webpack_public_path__ + "img/4_6.2389dfb0.png";